import { BrowserRouter, Routes, Route } from "react-router-dom";
import { configureStore } from "@reduxjs/toolkit";
import { Provider } from "react-redux";
import './App.css';
import productsSlice from "./features/productsSlice"
import AppProducts from "./comps/appProducts";
// הגדרת הסטור הגלובלי שיספוק פרובידר והסלייסים
// של הרידיוסר שהוא מכיל בתוכו
const myStore = configureStore({
  reducer: {
    productsSlice
  }
})

function App() {
  return (
    <BrowserRouter>
      <Provider store={myStore}>
        <Routes>
          <Route index element={<AppProducts />} />
          {/* כוכבית נשאיר לעמוד 404 אם לא מוצא אף
        ראוט יפעיל את מה שעם פאט' של כוכבית */}
          <Route path="*" element={<h2>Page 404, not found!</h2>} />
        </Routes>
      </Provider>
    </BrowserRouter>
  );
}

export default App;
